import React from 'react';
import packageJson from '../../package.json'; // 프로젝트 구조에 맞춰 package.json 경로 지정

export default function Footer(props) {
  const currentVersion = packageJson.version || '1.0.0';

  return (
    <div className="flex items-center justify-end border-t border-cust-line h-12 bg-cust-gray">
      <span className="font-bold text-sm p-3">버전 {currentVersion}</span>
    </div>
  );
}